import RoutesMap from "route_control/RouteControl"
import { Profile, UserList, AddUser, UpdateUser, UserDetails } from "pages/user"

const UsersRoute = () => {
    return [
        {
            path: RoutesMap.PROFILE.path,
            element: <Profile />
        },

        {
            path: RoutesMap.USER_LIST.path,
            element: <UserList />
        },
        {
            path: RoutesMap.ADD_USER.path,
            element: <AddUser />
        },
        {
            path: RoutesMap.UPDATE_USER.path,
            element: <UpdateUser />
        },
        {
            path: RoutesMap.USER_DETAILS.path,
            element: <UserDetails />
        },

    ]
}

export default UsersRoute;                          